var module = angular.module('octopusApp.projects');


module.controller('VolumeBindingDialogController', function ($scope, busy,
                                                             $uibModalInstance, projectId, binding, locals, existing) {
    $scope.isSaving = busy.create();
    $scope.locals = locals;
    $scope.binding = binding;
    binding.projectId = projectId;

    $scope.close = function() {
        $uibModalInstance.close();
    };

    $scope.save = function () {
        if ($scope.binding.container === '') {
            $scope.isSaving.showError('You must specify the container volume as an absolute path.');
            return;
        }
        $uibModalInstance.close($scope.binding);
    };
});





//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/actions/docker_run/volume-binding-dialog-controller.js
// module id = 501
// module chunks = 1